import React, { PureComponent } from 'react';
import { object, shape, array, func } from 'prop-types';
import { base64url_encode } from 'util/base64';
import * as constants from 'common/constants';
import { ErrorBoundary } from 'common/components';
import {
  CropsChart,
  dashboardHOC,
  DashboardProgressbox,
  RevenueChart,
  YieldChart,
} from 'containers';
import './index.css';

/**
 *
 *
 * @export
 * @class Dashboard
 * @extends {PureComponent}
 */
class Dashboard extends PureComponent {
  static displayName = 'Dashboard';

  /**
   *
   * Data for the Dashboard comes in from containers/dashboardHOC
   */
  static propTypes = {
    chartData: shape({
      cropChartData: array,
      revenueChartData: object,
      yieldChartData: object,
    }),
    refetch: func.isRequired,
  };

  render() {
    const {
      chartData: {
        cropChartData,
        revenueChartData,
        yieldChartData,
        storagesData,
        contractsData,
      },
      refetch,
    } = this.props;

    return (
      <ErrorBoundary>
        <div className="container dashboard">
          <div className="columns is-desktop">
            <div className="column is-half-desktop is-one-quarter-widescreen">
              <CropsChart data={cropChartData} />
            </div>
            <div className="column is-half-desktop is-three-quarters-widescreen">
              <YieldChart data={yieldChartData} refetch={refetch} />
            </div>
          </div>
          <div className="columns">
            <div className="column is-half">
              <DashboardProgressbox
                title="Storage"
                label={{ used: 'Filled', free: 'Free' }}
                source={storagesData.map(storage => {
                  const { id, crop, name, capacity } = storage;
                  return {
                    id,
                    crop,
                    title: name,
                    value: capacity ? capacity.used : 0,
                    max: capacity ? capacity.size : 0,
                    type: capacity ? capacity.type : 'bu',
                    url: `${constants.ROUTE_STORAGE_DETAIL}/${base64url_encode(
                      id.trim()
                    )}`,
                  };
                })}
                addURL={constants.ROUTE_STORAGE_ADD}
              />
            </div>
            <div className="column is-half">
              <DashboardProgressbox
                title="Contract"
                label={{ used: 'Delivered', free: 'Pending' }}
                showVariety={false}
                source={contractsData.map(contract => {
                  const {
                    id,
                    crop,
                    company,
                    quantity: { delivered, contracted },
                  } = contract;
                  return {
                    id,
                    crop,
                    title: company,
                    value: delivered ? delivered.size : 0,
                    max: contracted ? contracted.size : 0,
                    type: contracted ? contracted.type : 'bu',
                    url: `${
                      constants.ROUTE_CONTRACTS_DETAIL
                    }/${base64url_encode(id.trim())}`,
                  };
                })}
                addURL={constants.ROUTE_CONTRACTS_ADD}
              />
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <RevenueChart data={revenueChartData} />
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default dashboardHOC(Dashboard);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js